import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useModal } from 'hooks';
import apiReport from 'services/apis/report';
import { cooperplaceApi } from 'services/api';
import moment from 'moment';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { FaSearch } from 'react-icons/fa';
import ApplicationLayout from 'v3/layouts/Application';
import ChecklistResponseFilter from './Filter';
import useQuery from 'hooks/useQuery';
import { Row, Col } from 'react-bootstrap';
import CheckListDetailModal from 'v3/pages/Travel/Details/Checklist/CheckListDetailModal';
import { DataTable, Text, Space, Button, BadgeActive,} from 'v3/components';
import { useSnackbar } from 'v3/components/Snackbar';
import { usePermission } from 'hooks';


function getChecklistResponseStatus(status) {
  switch (status) {
    case 'INVALID':
      return <BadgeActive pill light type="error" className="mr-2">
        <Text type="label" weight={500}>
          Inválido
        </Text>
      </BadgeActive>;
    case 'EXPIRED':
      return <BadgeActive pill light type="error" className="mr-2">
        <Text type="label" weight={500}>
          Expirado
        </Text>
      </BadgeActive>;
    default:
      return <BadgeActive pill light type="success" className="mr-2">
        <Text type="label" weight={500}>
          Válido
        </Text>
      </BadgeActive>;
  }
}

export function ChecklistResponse() {

  usePermission('VISUALIZAR_RELATORIO_CHECKLIST_RESPONDIDOS', {
    redirect: true,
  });

  const queryParams = useQuery();
  const snackbar = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);

  const [data, setData] = useState([]);

  const checklistDetailModal = useModal();

  const [showAdvancedFiltersModal, setShowAdvancedFiltersModal] = useState(false);
  const [qtdAdvancedFilters, setQtdAdvancedFilters] = useState(0);
  const [selectedChecklistId, setSelectedChecklistId] = useState(null);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [travelId, setTravelId] = useState(null);

  const opemAttachment = async (row) => {
    setSelectedChecklistId(row?.travel_checklist_id);
    setTravelId(row?.travel_id);
  }

  const [pagination, setPagination] = useState({
    total: 0,
    lastPage: 1,
    currentPage: 1,
  });

  const [advancedFilters, setAdvancedFilters] = useState({
    drivers: [],
    vehicles: [],
    wagons: [],
    costCenters: [],
    negotiators: [],
    end_date: null,
    start_date: null,
    page: 1,
    per_page: 10
  });

  const fetchDetailChecklist = async () => {
    if (selectedChecklistId) {
      setLoading(true);
      setLoadingDetail(true);
      try {
        const { data } = await cooperplaceApi.get(
          `travel-checklist/checklist/${selectedChecklistId}`
        );
        setSelectedChecklist(data.data);
        checklistDetailModal.open();
        setSelectedChecklistId(null);
      } catch (error) {
        snackbar.show(<Text>Erro ao detalhar checklist da viagem</Text>, {
          type: 'error',
        });
      } finally {
        setLoadingDetail(false);
        setLoading(false);
      }
    }
  };

  const formatColumnsLink = ({ id, value }, link) => {
    if (id && value) {
      return (
        <Link
          to={`/${link}/${id}`}
          target="_blank"
          style={{ fontSize: '0.8rem' }}
        >
          {value}
        </Link>
      );
    } else {
      return '-';
    }
  };


  const formatColumnsImplement = (implement) => {

    if (!implement) {
      return '-'
    }

    const parts = implement.split(',');

    const result = parts.reduce((acc, curr, index) => {
      if (index % 2 === 0) {
        acc.push({ placa: curr, id: parts[index + 1] });
      }
      return acc;
    }, []);

    if (result.length > 0) {
      return result.map((item, index) => {
        const { placa, id } = item;

        return (
          <Link
            key={index}
            to={`/implementos/${id}`}
            target="_blank"
            style={{ fontSize: '0.8rem' }}
          >
            {index > 0 ? `, ${placa}` : placa}
          </Link>
        )
      })
    } else {
      return '-'
    }
  }

  const fetchData = useCallback(async (page = 1, per_page = 10) => {

    setLoading(true);

    try {

      const response = await apiReport.get(`checklist-response?page=${page}&per_page=${per_page}&${queryParams}`);
      const { data, ...rest } = response.data;

      setPagination(rest?.pagination);
      setData(data);

    } catch (error) {
      setData([]);
      const message =
        error?.response?.data?.message ||
        'Ocorreu um erro. Tente novamente mais tarde';
      snackbar.show(<Text>{`${message}`}</Text>, { type: 'error' });
    } finally {
      setLoading(false);
    }
  }, [queryParams]);

  async function changePage(page) {
    setAdvancedFilters({ ...advancedFilters, page: page });
    fetchData(page, advancedFilters?.per_page);
  }

  async function changePerPage(per_page) {
    setAdvancedFilters({ ...advancedFilters, per_page: per_page });
    fetchData(advancedFilters?.page, per_page);
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedChecklistId) {
      fetchDetailChecklist();
    }
  }, [selectedChecklistId]);

  return (
    <ApplicationLayout
      title={"Relatório checklists respondidos"}
      RightComponent={
        <Space x="0.25rem" y="0.25rem">
          <Button
            variant="secondary"
            onClick={() => setShowAdvancedFiltersModal(true)}
            disabled={loading || loadingDetail}
          >
            <Text
              weight={500}
            >{`Filtro Avançado (${qtdAdvancedFilters})`}</Text>
          </Button>
        </Space>
      }
    >
      {
        loadingDetail ? (
          <Row className="d-flex mx-2 mt-2 mb-2 justify-content-between" style={{backgroundColor: '#fff',borderRadius: '0.5rem'}}>
            <Col className="align-self-center">
              <SkeletonTheme>
                <Col>
                  <Skeleton count={4} className="my-3" />
                </Col>
              </SkeletonTheme>
            </Col>
          </Row>
        ) : (
          <>
            <Row style={{ marginBottom: '3rem' }}>
              <ChecklistResponseFilter
                loading={loading}
                onChange={fetchData}
                showAdvancedFiltersModal={showAdvancedFiltersModal}
                setShowAdvancedFiltersModal={setShowAdvancedFiltersModal}
                setQtdAdvancedFilters={setQtdAdvancedFilters}
                queryParams={queryParams}
                setAdvancedFilters={setAdvancedFilters}
                advancedFilters={advancedFilters}
              />
            </Row>
            <DataTable
              data={data}
              loading={loading}
              withFilterOption={false}
              tableStyles={{
                borderCollapse: 'collapse',
                '> thead > tr > th': {
                  borderBottom: '2px solid #D1D5DB !important',
                },
                '> tbody > tr': {
                  borderBottom: '1px solid #E5E7EB !important',
                },
                '> tbody > tr > td': {
                  borderBottom: '1px solid #E5E7EB !important',
                },
                '> tbody > tr:hover': {
                  background: '#F5F6F8 !important',
                },
                '> tbody > tr:hover > td': {
                  background: '#F5F6F8 !important',
                },
              }}
              page={pagination?.currentPage}
              pages={pagination?.lastPage}
              total={pagination?.total}
              onPageChanged={changePage}
              onPerPageChanged={changePerPage}
              defaultPerPage={advancedFilters?.per_page}
              perPageOptions={[{ v: 10 }, { v: 20 }, { v: 30 }, { v: 50 }]}
              columns={[
               {
                name: 'Status',
                  selector: row => getChecklistResponseStatus(row?.status),
                },
                {
                  name: 'Nº Checklist',
                  selector: row =>
                    row.checklist_id ? (
                      <Link
                        to={`/checklist/${row.checklist_id}`}
                        target="_blank"
                        style={{ fontSize: '0.8rem' }}
                      >
                        {row.checklist_id}
                      </Link>
                    ) : (
                      '-'
                    ),
                },
                {
                  name: 'Incluído em',
                  selector: row =>
                    row?.included_at
                      ? moment(row.included_at).format('DD/MM/YYYY HH:mm:ss')
                      : '-',
                  style: { minWidth: '140px' },
                },
                {
                  name: 'Viagem principal',
                  selector: row => formatColumnsLink({
                    id: row?.travel_id,
                    value: row?.travel_id,
                  },
                    'viagens'
                  ),
                },
                {
                  name: 'Centro de Custo',
                  selector: row => row?.cost_center_name || '-',
                },
                {
                  name: 'Negociador',
                  selector: row => formatColumnsLink({
                    id: row?.negotiator_id,
                    value: row?.negotiator_name,
                  },
                    'usuarios'
                  ),

                },
                {
                  name: 'Cliente tomador',
                  selector: row => formatColumnsLink({
                    id: row?.client_taker_id,
                    value: `${row?.client_social_name} - ${row?.client_cpf_cnpj}`,
                  },
                    'clientes'
                  ),
                },

                {
                  name: 'Veículo',
                  selector: row => formatColumnsLink({
                    id: row?.vehicle_id,
                    value: row?.vehicle_plate,
                  },
                    'veiculos'
                  ),
                },
                {
                  name: 'Implementos',
                  selector: row => formatColumnsImplement(row?.implement)
                },
                {
                  name: 'Motorista resposta',
                  selector: row => formatColumnsLink({
                    id: row?.driver_id,
                    value: row?.driver_social_name,
                  },
                    'motoristas'
                  ),
                },

                {
                  name: '',
                  selector: row => (
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => opemAttachment(row)}
                    >
                      Detalhes
                    </Button>
                  ),
                  style: { textAlign: 'center' },
                },
              ]}
            />
          </>
        )
      }
      <CheckListDetailModal
        mode="report"
        checklist={selectedChecklist}
        modalHook={checklistDetailModal}
        hideExport
        hideToSingButton
        handleClose={() => setSelectedChecklist(null)}
        travelData={{ id: travelId }}
      />
    </ApplicationLayout>
  )
}
